
import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';

function Navbar() {
  const [isFixed, setIsFixed] = useState(false);
  const [isHiding, setIsHiding] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;
      const scrollPosition = window.scrollY;

      // ビューポートの高さ以上スクロールした場合（展望セクション以下）
      if (scrollPosition >= viewportHeight) {
        if (!isFixed && !isHiding) {
          setIsFixed(true);
          setIsHiding(false);
        }
      } else {
        if (isFixed) {
          setIsHiding(true);
          setTimeout(() => {
            setIsFixed(false);
            setIsHiding(false);
          }, 300); // アニメーション時間と合わせる
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isFixed, isHiding]);

  const getNavbarClass = () => {
    if (isHiding) return 'navbar navbar-hiding';
    if (isFixed) return 'navbar navbar-fixed';
    return 'navbar navbar-absolute';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={getNavbarClass()}>
      <div className="navbar-logo-mobile">
        <a href="#home">
          <img src={`${process.env.PUBLIC_URL}/Logo.svg`} alt="VR Project Logo" className="navbar-logo-img" />
        </a>
      </div>

      <button
        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="メニュー"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`navbar-links ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        <li className="navbar-logo-item navbar-logo-desktop">
          <a href="#home" onClick={closeMobileMenu}>
            <img src={`${process.env.PUBLIC_URL}/Logo.svg`} alt="VR Project Logo" className="navbar-logo-img" />
          </a>
        </li>
        <li><a href="#home" onClick={closeMobileMenu}>Home</a></li>
        <li><a href="#outlook" onClick={closeMobileMenu}>Outlook</a></li>
        <li><a href="#main-activities" onClick={closeMobileMenu}>Activities</a></li>
        <li><a href="#news" onClick={closeMobileMenu}>News</a></li>
        <li><a href="#join" onClick={closeMobileMenu}>Join</a></li>
        <li><a href="#contact" onClick={closeMobileMenu}>Contact</a></li>
        <li><a href="#sns" onClick={closeMobileMenu}>SNS</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
